import { LazyImport, LazyModule } from 'owa-bundling';
export { default as reInitLpc } from './actions/reInitLpc';
export { initializePersona } from './personaConfig';
export { getOwsPersonaByEmailAddress } from './dataLayer/getOwsPersonaByEmailAddress';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "OwaPersona" */ './lazyIndex'));

export const lazyInitializeLivePersonaCardAsync = new LazyImport(
    lazyModule,
    m => m.initializeLivePersonaCardAsync
);

export const changeModuleOrchestrator = new LazyImport(
    new LazyModule(
        () =>
            import(
                /* webpackChunkName: "ChangeModuleOrchestrator" */ './orchestrators/changeModuleOrchestrator'
            )
    ),
    m => m.default
);
